import { faLocationDot } from '@fortawesome/pro-solid-svg-icons'
import { Icon } from '../../icon/Icon'

export const PlotMarker = () => {
  return (
    <Icon
      icon={faLocationDot}
      size="extra-small"
      style={{ borderRadius: '0.5rem', background: 'var(--fine-pink)' }}
    />
  )
}
